import script from "./ProgressModuleGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressModuleGridView.vue?vue&type=script&setup=true&lang=js"

import "./ProgressModuleGridView.vue?vue&type=style&index=0&id=45bd0ef3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45bd0ef3"]])

export default __exports__